import React from 'react';
import { connectWithCore } from 'framework/hocs';
import { Segment, Pagination, Button, Grid, Loader, Icon, Form } from 'semantic-ui-react';
import { FemaGoModal, FemaGoTable } from 'app-ui-componentlibrary';
import { Link } from 'react-router-dom';
import REST from 'go/requests/rest';
import _ from 'lodash';
import ManageGroupForm from './ManageGroupForm';
import { AddNewGroup } from './AddNewGroup';


export class ManageGroupsPageV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      pageNum: 0,
      error: false,
      loading: false,
      numGroups: 0,
      errorMessage: '',
      totalPages: 0,
      categories: [],
      tempOptions: [],
      allGroups: [],
      selectedGroup: [],
      showModal: false,
      newGroupId: '',
      checkAll: false,
      modalType: null,
      newGroup: '',
      category: ''
    };
  }

  getGroups = () => {
    const { token, sessionId } = this.props;
    const pageSize = 20;
    this.setState({
      loading: true,
    });
    return REST.panelReviewV2
      .getGroupsBySession(token, sessionId, this.state.pageNum, pageSize)
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (_.size(_.get(res, 'content')) === 0) {
          this.setState({
            error: true,
            loading: false,
          });
        } else {
          this.setState({
            groups: [...res.content],
            error: false,
            loading: false,
            numGroups: res.totalElements,
            totalPages: res.totalPages,
          });
        }
      })
      .catch((err) => {
        this.setState({
          error: true,
          loading: false,
          errorMessage: 'There was an error retrieving groups. Please refresh the page.',
        });
      });
  };

  getCategories = () => {
    const { sessionId } = this.props
    return REST.panelReviewV2
      .fetchAllCategories(sessionId)
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (res.length === 0) {
          this.setState({
            error: true,
            loading: false
          })
        } else {
          if (res && res.length) {
            const cats = []
            res.map((category) => {
              const categoryObj = {}
              categoryObj['name'] = category
              categoryObj['checked'] = false
              cats.push(categoryObj)
            })
            this.setState({
              categories: cats
            })
          }
        }

      })
  }

  updateSelectedGroup = async (selectedGroup, suspended) => {
    const { token, sessionId } = this.props

    const checkChecked = this.state.categories.some((category) => {
      return category.checked === true
    })

    if (!checkChecked) {
      this.setState({
        error: true,
        errorMessage: "You havee to select at least one category"
      })

      return
    }

    const payloadCategories = this.state.categories.filter(category => category.checked).reduce((acc, category) => {
      return [...acc, category.name]
    }, [])

    const formatPayloadCategories = payloadCategories.map((category) => {
      return { groupId: this.state.selectedGroup.groupId, category }
    })

    const payload = {
      sessionId, token,
      suspended,
      groupId: selectedGroup.groupId,
      categories: formatPayloadCategories
    }

    const suspendedObj = {
      suspended: this.state.selectedGroup.suspended
    }

    return REST.panelReviewV2
      .updateGroup(payload)
      .then(REST.handler.handleResponse)
      .then((res) => {
        REST.panelReviewV2.updateSuspendedDataForGroup(null, this.state.selectedGroup.groupId, sessionId, suspendedObj)
          .then(REST.handler.handleResponse)
          .then((res) => {
            this.getGroups()
          })
      })
      .catch((error) => {
        this.setState({
          error: true,
          errorMessage: "Unable to update group details"
        })
      })
  }

  addNewGroup = async (groupName) => {
    let { token, sessionId } = this.props
    const checkChecked = this.state.categories.some((category) => {
      return category.checked === true
    })

    if (!checkChecked) {
      this.setState({
        error: true,
        errorMessage: "You have to select at least one category"
      })

      return
    }

    if (!groupName || groupName === '') {
      this.setState({
        error: true,
        errorMessage: "You havee to  specify a group name"
      })

      return
    }

    const payloadCategories = this.state.categories.filter(category => category.checked).reduce((acc, category) => {
      return [...acc, category.name]
    }, [])

    const payload = {
      sessionId: +sessionId,
      suspended: true,
      name: groupName,
      categories: payloadCategories
    }

    return REST.panelReviewV2
      .addGroup(token, sessionId, payload)
      .then(REST.handler.handleResponse)
      .then((res) => {
        this.setState({
          groups: [res, ...this.state.groups]
        })

      })
      .catch((error) => {
        this.setState({
          error: true,
          errorMessage: "Unable to add a new group"
        })
      })
  }

  modifyGroupCategories = (categories) => {
    return Array.isArray(categories) && categories.length > 0
      ? categories.map((category) => category.groupCategoryId.category).join("; ")
      : null;
  };

  handlePageChange = async (e, { activePage }) => {
    await this.setState({ pageNum: activePage - 1 });
    this.getGroups();
  };

  clearCategorySelection = () => {
    const categories = this.state.categories
    _.forEach(categories, category => {
      category.checked = false;
    })
    this.setState({
      categories:categories,
    });
  }

  openManageTeamModal = (group, modalType = 'manage') => {
    this.clearCategorySelection()
    let groupCategories = _.get(group, 'categories')
    groupCategories = _.map(groupCategories, category => {
      return _.get(category, 'groupCategoryId.category')
    })
    const categories = this.state.categories
    const newCategores = categories.map((category) => {
      if (_.includes(groupCategories,category.name)) {
        category.checked = true
      }

      return category
    })
    if (group && modalType === 'manage') {
      this.setState({
        manageModalVisible: !this.state.manageModalVisible,
        selectedGroup: group,
        categories:newCategores,
        modalType
      });
    } else {
      this.setState({
        manageModalVisible: !this.state.manageModalVisible,
        modalType
      });
    }
  };

  handleSelectCategory = (data) => {
    const categories = this.state.categories
    const newCategores = categories.map((category) => {
      if (category.name === data.name) {
        category.checked = !category.checked
      }

      return category
    })

    this.setState({
      categories: newCategores
    })
  }

  handleChangeStatus = (selectedGroup, suspended=false) => {
    const newGroups = this.state.groups;
    newGroups.forEach(group => {
      if (group.groupId === selectedGroup.groupId) {
        group.suspended = suspended;
      }
    });

    this.setState({
      groups: newGroups,
    });
  }


  selectAllCategories = (data, check) => {
    data.map((category) => {
      category.checked = check
    })
    this.setState({
      categories: data
    })
  }

  componentDidMount() {
    this.getGroups();
    this.getCategories();
  }

  renderTable(groups) {
    if (groups && groups.length) {
      return _.map(groups, (group) => {
        return (
          <FemaGoTable.Row key={group.groupId}>
            <FemaGoTable.TextCell>
              {group.name}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>{this.modifyGroupCategories(group.categories)}</FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {group.suspended ? 'Inactive' : 'Active'}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              <a
                LinkTo=''
                title={`Manage`}
                className='table-link'
                onClick={(e) => {
                  e.preventDefault();
                  this.openManageTeamModal(group);
                }}
                href='javascript:void(0);'
              >
                <Icon name="group" />
                Manage
              </a>
            </FemaGoTable.TextCell>
          </FemaGoTable.Row>
        );
      });
    } else {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.TextCell> </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    }
  }

  render() {
    const { groups, error, pageNum, totalPages, loading, errorMessage } = this.state;
    const { aliases } = this.props;
    const category = _.get(_.find(aliases, { value: 'category' }), 'label');

    if (loading)
      return (
        <Loader inline="centered" active>
          Loading...
        </Loader>
      );
    return (
      <React.Fragment>
        {error ? (
          <p>{errorMessage ? errorMessage : 'There are currently no groups to display.'}</p>
        ) : (
          <React.Fragment>
            <Segment>
              <Grid>
                <Grid.Column width={16} textAlign="right">
                  <Button
                    primary
                    onClick={() => {
                      this.openManageTeamModal(null, 'add');
                    }}
                  >
                    Add new group
                  </Button>
                  <AddNewGroup
                    loading={this.state.loading}
                    selectedGroup={this.state.selectedGroup}
                    categories={this.state.categories}
                    groups={this.state.groups}
                    openManageTeamModal={this.openManageTeamModal.bind(this)}
                    closeManageTeamModal={this.openManageTeamModal.bind(this)}
                    manageModalVisible={this.state.manageModalVisible}
                    selectAllCategories={this.selectAllCategories}
                    handleSelectCategory={this.handleSelectCategory}
                    token={this.props.token}
                    sessionId={this.props.sessionId}
                    handleChangeStatus={this.handleChangeStatus}
                    updateSelectedGroup={this.updateSelectedGroup}
                    modalType={this.state.modalType}
                    addNewGroup={this.addNewGroup}

                  />

                </Grid.Column>
              </Grid>
              <FemaGoTable summary="Manage groups table">
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell>Group name</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>{category}</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Actions</FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                {!this.state.error && (
                  <FemaGoTable.Body>{this.renderTable(groups)}</FemaGoTable.Body>
                )}
              </FemaGoTable>
            </Segment>
            <Pagination
              activePage={pageNum + 1}
              firstItem={null}
              lastItem={null}
              siblingRange={1}
              boundaryRange={1}
              ellipsisItem={null}
              totalPages={totalPages}
              onPageChange={this.handlePageChange}
            ></Pagination>
            <ManageGroupForm
              loading={this.state.loading}
              selectedGroup={this.state.selectedGroup}
              categories={this.state.categories}
              groups={this.state.groups}
              openManageTeamModal={this.openManageTeamModal.bind(this)}
              closeManageTeamModal={this.openManageTeamModal.bind(this)}
              manageModalVisible={this.state.manageModalVisible}
              selectAllCategories={this.selectAllCategories}
              handleSelectCategory={this.handleSelectCategory}
              handleChangeStatus={this.handleChangeStatus}
              updateSelectedGroup={this.updateSelectedGroup}
              modalType={this.state.modalType}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default connectWithCore(ManageGroupsPageV2);
